module.exports = __webpack_public_path__ + "img/Etraveli.a186b041.png";